import {
  Box,
  Button,
  Center,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { RiSendPlaneLine } from "@remixicon/react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import ImageComparing from "../designComponents/ImageComparing/ImageComparing";
import Publish from "../publish";
import KongImage from "@/assets/images/st_kong.gif";
import { selectCurrentImage } from "@/reducer/designslice";

const CurrentImagePreview2 = () => {
  const publishControl = useDisclosure();
  const previewControl = useDisclosure();
  const [currentContentId, setCurrentContentId] = useState("");
  const [showComparing, setShowComparing] = useState(false);
  const currentImage = useSelector(selectCurrentImage);

  useEffect(() => {
    setShowComparing(false);
  }, [currentImage]);

  const handlePublish = () => {
    setCurrentContentId(currentImage.id);
    publishControl.onOpen();
  };

  return (
    <Flex
      sx={{
        width: "full",
        height: "full",
        position: "relative",
      }}
    >
      {!currentImage.image_url && (
        <Flex
          overflow="auto"
          sx={{
            width: "full",
            height: "full",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Box color="#5B5F6D" textAlign="center" fontSize="18px">
            <Image w="180px" h="198px" src={KongImage} />
            <Text>暂时还没有图片</Text>
            <Text>快去输入你的创意描述</Text>
          </Box>
        </Flex>
      )}

      {currentImage.image_url && (
        <Flex
          flexDirection="column"
          sx={{
            width: "full",
            height: "full",
            bg: "#0C0B10",
            position: "absolute",
          }}
        >
          <Box h="0" flex={1} mt="10px" mb="10px">
            {!showComparing && (
              <Image
                objectFit="contain"
                draggable={false}
                w="100%"
                h="100%"
                src={currentImage.image_url}
                cursor="zoom-in"
                onClick={previewControl.onOpen}
              />
            )}
            {showComparing && (
              <ImageComparing
                image={currentImage}
                compareImageSrc={currentImage.ref_structure}
              />
            )}
          </Box>
          <Center gap="20px">
            <Button
              w="72px"
              h="32px"
              leftIcon={<RiSendPlaneLine size="16px" />}
              variant="unstyle"
              borderRadius={0}
              bg="rgba(28, 35, 55, 0.4)"
              color="#fff"
              fontSize="14px"
              fontWeight="bold"
              _hover={{
                bg: "#496AE1",
              }}
              onClick={handlePublish}
            >
              发布
            </Button>
          </Center>
        </Flex>
      )}

      {currentContentId && (
        <Publish
          isOpen={publishControl.isOpen}
          onClose={publishControl.onClose}
          contentId={currentContentId}
        />
      )}

      <Modal
        isOpen={previewControl.isOpen}
        onClose={previewControl.onClose}
        isCentered
        size="4xl"
      >
        <ModalOverlay bg="rgba(0, 0, 0, 0.72)" backdropFilter="blur(6px)" />
        <ModalContent
          bg="#0C0B10"
          border="1px solid #27314D"
          borderRadius="20px"
          boxShadow="0 24px 64px rgba(0, 0, 0, 0.42)"
        >
          <ModalCloseButton
            color="rgba(255, 255, 255, 0.72)"
            _hover={{ color: "#FFFFFF", bg: "rgba(255, 255, 255, 0.08)" }}
          />
          <ModalBody p="16px">
            {currentImage.image_url && (
              <Image
                src={currentImage.image_url}
                alt="current-image-preview"
                w="100%"
                maxH="78vh"
                objectFit="contain"
                borderRadius="14px"
                bg="rgba(255, 255, 255, 0.03)"
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default CurrentImagePreview2;
